import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import * as routes from './routes'
import Icon from 'react-icons-kit'
import { lock } from 'react-icons-kit/fa/lock'

import SignIn from './SignIn'

import './LoginRequired.css'

class LoginRequired extends Component {
    render() {
        return (
            <div className='LoginRequired_container card'>
                <Icon size={50} icon={lock} className='status_complete' />
                <h1>Sign In</h1>
                <br/>
                <h4>Click below to sign in or create an account.</h4>
                <br/>
                <SignIn>
                    <button className='custom_btn'>Sign In</button>
                </SignIn>
            </div>
        )
    }
}

export default LoginRequired
